import './App.scss';

import Navigation from './components/Nav.jsx';
import Footer from './components/Footer.jsx';

// appHeight necessary to set css variable --app-height on <html>
import appHeight from './appHeight.jsx';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <Navigation />
      <Footer />
      <ToastContainer />
    </>
  );
}

export default App;
